import type { CreateClientConfig } from './client/client.gen';

// baseURL is set at bootstrap from runtime config (config.json apiUrl).
// throwOnError makes the SDK reject on non-2xx so TanStack Query sees failures.
export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  throwOnError: true,
  baseURL: '',
});
